import { useCustomSuspenseQuery } from "@/hooks/use-graphql-client";

import { SnackNewItem_SnackEditPage_Query } from "./query";

type Props = {
	hotelID: string;
	duplicateItemID: string | undefined;
};

export const useSnackNewItemQuery = ({ hotelID, duplicateItemID }: Props) => {
	const { data } = useCustomSuspenseQuery(SnackNewItem_SnackEditPage_Query, {
		variables: {
			hotelID,
			duplicateUUID: duplicateItemID,
		},
	});

	return {
		data,
	};
};
